import reportReducer from './';

export default reportReducer;
